export const formRecaptchaMixin = {
  data: () => ({
    recaptchaToken: null
  }),
  methods: {
    onCapchaRegister (recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      if (this.isValid) this.sendForm();
    },
    onCaptchaExpired () {
      if (!this.$refs?.recaptcha) {
        console.error('provide ref for recaptcha component')
        return;
      }

      this.$refs.recaptcha.reset();
    },
    errorCaptcha () {
      console.error('errorCaptcha');
    },
    executeRecaptcha () {
      if (!this.$refs?.recaptcha) {
        console.error('provide ref for recaptcha component');
        return;
      }

      this.$refs.recaptcha.execute();
    }
  }
}


// WEBPACK FOOTER //
// ./src/templates/components/mixins/form-recaptcha.js